import { render, staticRenderFns } from "./ErrorMessage.vue?vue&type=template&id=1f00130b&"
import script from "./ErrorMessage.vue?vue&type=script&lang=js&"
export * from "./ErrorMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f00130b')) {
      api.createRecord('1f00130b', component.options)
    } else {
      api.reload('1f00130b', component.options)
    }
    module.hot.accept("./ErrorMessage.vue?vue&type=template&id=1f00130b&", function () {
      api.rerender('1f00130b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2X2jv0xHzqH3C/JS/comp/ErrorMessage.vue"
export default component.exports